import { DiscAlertIcon } from './DiscAlertIcon';

/**
 * author: Google
 * id 63A41E0F-CCDB-42F8-848B-F64AA94F9BDF
 * name disc-alert
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/disc-alert.svg
 * tags
 * - Alert / Error 
 */
export const DiscFullIcon = DiscAlertIcon;
export default DiscFullIcon